(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .filter('standardReportDefaultNumber', standardReportDefaultNumber)
      .filter('standardReportNumber', standardReportNumber)
      .filter('metricChangeNumber', metricChangeNumber);

  // @ngInject
  function standardReportNumber(numberFilter, standardReportDefaultNumberFilter) {
    return function (number) {
      if (number) {
        return numberFilter(number);
      } else {
        return standardReportDefaultNumberFilter(number);
      }
    };
  }

  // @ngInject
  function standardReportDefaultNumber() {
    return function (number) {
      return _.isFinite(number) || _.isString(number) ? number : '-.-';
    };
  }

  // @ngInject
  function metricChangeNumber(standardReportDefaultNumberFilter) {
    return function (number) {
      if (number) {
        return _.gte(number, 0) ? '+' + number : number;
      } else {
        return standardReportDefaultNumberFilter(number);
      }
    };
  }

})();
